<ap-modal #baseModal
          [appModalId]="'match-tracker'"
          [ariaLabel]="'Match with Tracker'"
          [title]="'Match with Tracker'"
          [closable]="true"
          [alignment]="'top'"
          [style]="{'width': '75rem'}"
          [styleClass]="'gtw-web-components'"
          (onClose)="closeModalOk('match-tracker')">
  <div class="match-tracker-modal-body">
    <div class="table-container">
      @if (loadingStatements) {
<div class="ap-mt-spacing-2">
        <span>
          <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
        </span>
      </div>
}
      @if (!loadingStatements) {
<ap-table #table [data]="tableData" [striped]="true">
        <table>
        <caption class="sr-only">Statement match tracker</caption>
        <thead class="a-thead">
        <tr>
          <th>Action</th>
          <th ap-sort [sortKey]="'STATEMENT_ID'">Statement Id</th>
          <th ap-sort [sortKey]="'PRIMARYENTITY'">Primary Entity</th>
          <th ap-sort [sortKey]="'STATEMENTNAME'">Statement Name</th>
          <th ap-sort [sortKey]="'SECONDARYENTITY'">Secondary Entity</th>
          <th ap-sort [sortKey]="'CREATEDBY'">Created By</th>
        </tr>
        </thead>
        <tbody class="a-tbody tbody-regular tbody-hover">
        @if (tableData.length === 0) {
<tr>
          <td colspan="6" class="no-data-cell">No Data</td>
        </tr>
}
        @for (item of tableData; track $index) {
<tr>
          <td>
            <div>
              <ap-button [btnType]="'primary'" class="btn-match" [compact]="true" [disabled]="saving" (onClick)="matchTo(item)">
                <span class="Appkit4-icon icon-plus-fill"></span>
                Match to This
              </ap-button>
            </div>
          </td>
          <td>{{item.STATEMENT_ID}}</td>
          <td>{{item.PRIMARYENTITY}}</td>
          <td>{{item.STATEMENTNAME}}</td>
          <td>{{item.SECONDARYENTITY}}</td>
          <td>{{item.CREATEDBY}}</td>
        </tr>
}
        </tbody>
        </table>
      </ap-table>
}
    </div>
  </div>
  <ng-template ngTemplate="footer">
    <div class="footer-content">
      <div class="mt-label">If you don't find the statement ID above, please enter the statement ID here and save.</div>
      <ap-field [style]="'margin-right: 10px;'" [title]="''" [fieldId]="'1'" [hideTitleOnInput]="true">
        <input appkit-field [(ngModel)]="statementId" aria-label="Statement ID" />
      </ap-field>
      <div class="ap-mt-spacing-2">
        @if (saving) {
<span>
          <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
        </span>
}
      </div>
      @if (!saving) {
<ap-button [compact]="true" [btnType]="'text'" [label]="'SAVE'" [icon]="'plus-fill'" [disabled]="loadingStatements || statementId === ''" (onClick)="save()"></ap-button>
}
      <ap-button [compact]="true" [btnType]="'text'" [label]="'CLOSE'" (onClick)="closeModalOk('copy-replicate')"></ap-button>
    </div>
  </ng-template>
</ap-modal>

